import type { Nav4RolloutEap } from '../../../types.tsx';
import { getIsNav4UserOptOut } from '../../get-meta-boolean/index.tsx';

export const getNav4RolloutForEap = (): Nav4RolloutEap => ({
	stage: 'eap',
	isUserOptOut: getIsNav4UserOptOut(),
});
